<ng-container *ngIf="product$ | async as product">
  <div
    *ngIf="!product.failed"
    class="product-tile-list row align-items-md-center product-retail-set"
    [attr.data-testing-sku]="product.sku"
  >
    <div class="col-3 p-0 pl-1">
      <div class="product-image-container">
        <ish-product-image imageType="M" [link]="true"></ish-product-image>
        <ish-product-label></ish-product-label>
        <!-- DIAS Customization - Marketing Bug -->
        <custom-product-marketing-label></custom-product-marketing-label>
      </div>
    </div>

    <div class="col-9">
      <div class="row">
        <div class="col-lg-7">
          <ish-product-name></ish-product-name>

          <ish-lazy-product-rating
            *ngIf="configuration$('ratings') | async"
            [hideNumberOfReviews]="true"
          ></ish-lazy-product-rating>

          <ish-product-price
            [showInformationalPrice]="true"
            *ngIf="!(configuration$('isRetailPart') | async)"
          ></ish-product-price>

          <ish-product-id></ish-product-id>

          <div
            *ngIf="configuration$('description') | async"
            class="product-description"
            [ishServerHtml]="product.shortDescription"
          ></div>

          <!-- <ish-product-promotion displayType="simpleWithDetail"></ish-product-promotion> -->

          <!-- <div class="product-tile-actions btn-group">
            <ish-lazy-product-add-to-quote displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-quote>
            <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-compare>
            <ish-lazy-product-add-to-wishlist displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-wishlist>
            <ish-lazy-product-add-to-order-template
              displayType="icon"
              cssClass="btn-link"
            ></ish-lazy-product-add-to-order-template>
          </div> -->
        </div>

        <div class="col-lg-5">
          <ish-product-price
            [showInformationalPrice]="true"
            *ngIf="configuration$('isRetailPart') | async"
          ></ish-product-price>
          <ish-product-inventory></ish-product-inventory>

          <ish-product-item-variations></ish-product-item-variations>

          <div class="product-list-actions-container">
            <ish-lazy-tacton-configure-product displayType="list-button"></ish-lazy-tacton-configure-product>

            <div class="product-form form-horizontal row justify-content-md-end">
              <ng-container *ngIf="configuration$('readOnly') | async; else quantityInput">
                <div class="action-container col-12 col-xl-7">
                  <span *ngIf="configuration$('quantity') | async"
                    >{{ 'product.quantity.label' | translate }}: {{ quantity$ | async }}</span
                  >
                </div>
              </ng-container>
              <ng-template #quantityInput>
                <div class="action-container col-lg-5">
                  <ish-product-quantity></ish-product-quantity>
                </div>
              </ng-template>

              <!-- <div class="action-container addtocart-container col-12 col-lg-7">
              <ish-product-add-to-basket></ish-product-add-to-basket>
              <ish-product-choose-variation></ish-product-choose-variation>
            </div> -->
            </div>
            <ish-product-shipment></ish-product-shipment>
            <a *ishFeature="'quickView'" [routerLink]="[]" (click)="openQuickView(product.sku)">
              <span class="product-variation">QUICK VIEW</span>
            </a>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="product-list-buttons-container">
          <div class="product-list-actions">
            <ish-lazy-product-add-to-order-template
              displayType="icon"
              cssClass="btn-link product-list-action-buttons btn-circle"
            >
            </ish-lazy-product-add-to-order-template>
            <ish-lazy-product-add-to-compare
              displayType="icon"
              cssClass="btn-link product-list-action-buttons btn-circle mx-2"
            ></ish-lazy-product-add-to-compare>
            <ish-lazy-product-add-to-wishlist
              displayType="icon"
              cssClass="btn-link product-list-action-buttons btn-circle"
            ></ish-lazy-product-add-to-wishlist>
          </div>

          <div class="product-list-add-to-cart">
            <ish-product-add-to-basket></ish-product-add-to-basket>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
